import { Controller } from 'stimulus';

// Opens and scrolls to the task-page section a legacy /pannel/ URL pointed
// at (e.g. /nav/info/pannel/details now lands on Summary › Task Details).
// <div data-controller="reveal-section" data-reveal-section-id="details">
export default class extends Controller {
  connect() {
    const id = this.data.get('id');
    const section = id && (document.getElementById(`sec_${id}`) || document.getElementById(id));
    if (!section) return;

    const details = section.tagName === 'DETAILS' ? section : section.querySelector('details');
    if (details) details.open = true;
    section.scrollIntoView({ behavior: 'auto', block: 'start' });
  }
}
